module.exports = __webpack_public_path__ + "img/tier1-2.c2047ac6.png";